import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { CompetenciesService } from '../competencies/competencies.service';
import { MatSort } from '@angular/material/sort';
import { DialogForCompetencyComponent } from 'src/app/components/dialog-for-competency/dialog-for-competency.component';
import { EditCompetencyDialogComponent } from './components/edit-competency-dialog/edit-competency-dialog.component';
import { ViewCompetencyDialogComponent } from './components/view-competency-dialog/view-competency-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ExcelService } from 'src/app/services/excel-service.service';
import { SelectionModel } from '@angular/cdk/collections';
import * as XLSX from 'xlsx-js-style';
import { ModularConfirmDialogComponent } from './components/modular-confirm-dialog/modular-confirm-dialog.component';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-field-missing-employees',
  templateUrl: './field-missing-employees.component.html',
  styleUrls: ['./field-missing-employees.component.css']
})
export class FieldMissingEmployeesComponent implements OnInit {
  //"email", "sourceSystemName", 
  displayedColumns = ["select", "employeeId", "employeeName", "primarySkills", "secondarySkills", 
                      "assignedComp", "assignedSubComp", "requestedComp", "requestedSubComp", "subCOELead", 
                      "coeLead", "status", "actions"];
  selection = new SelectionModel<any>(true, []);
  searchText: string = "";
  from: number = 0;
  size: number = 10;
  loading: boolean = true;
  totalRecords: number = 0;
  public dataSource: MatTableDataSource<any>;
  filterStatus : boolean=false;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  loggedInUserId: number = 0;
  statusOptions = [
    { label: 'Requested For Change', value: "requested", checked: false },
    { label: 'Unassigned', value: "Unassigned", checked: false }
  ];
  competencyFilterOptions: any[] = [];
  subCompetencyFilterOptions: any[] = [];
  coeFilterOptions: any = [];
  subCOEFilterOptions: any[] = [];
  isSuperAdmin: boolean = false;
  skipNextPageEvent = false;

  constructor(
    private excel: ExcelService,
    private _competencyService: CompetenciesService,
    public dialog: MatDialog,
    private toaster: ToastrService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    const roles = localStorage.getItem("role") || "";
    this.isSuperAdmin = roles.split(",").map(r => r.trim()).includes("SuperAdmin");
    this.GetNoCompetencyData();
    this.loggedInUserId = parseInt(localStorage.getItem("Id"));
    this.getFiltersData();
  }

  getFiltersData() {
    this.loading = true;
    this._competencyService.GetSubCOEFilterData().subscribe(x => {
      const coeMap = new Map();
      const subCOEMap = new Map();
      const competencyMap = new Map();
      const subCompetencyMap = new Map();

      x.data.forEach(item => {
        if (!coeMap.has(item.coeEmployeeId)) {
          coeMap.set(item.coeEmployeeId, {
            coeEmployeeId: item.coeEmployeeId,
            coeName: item.coeName,
            label: item.coeName,
            value: item.coeEmployeeId,
            checked: false,
            competencyIds: [item.competencyId]
          });
        } else {
          coeMap.get(item.coeEmployeeId).competencyIds.push(item.competencyId);
        }
        if (item.subCOEEmployeeId && item.subCOEName) {
          if (!subCOEMap.has(item.subCOEEmployeeId)) {
            subCOEMap.set(item.subCOEEmployeeId, {
              subCOEEmployeeId: item.subCOEEmployeeId,
              subCOEName: item.subCOEName,
              label: item.subCOEName,
              value: item.subCOEEmployeeId,
              checked: false,
              hidden: false,
              assignments: [{
                competencyId: item.competencyId,
                subCompetencyId: item.subCompetencyId
              }]
            });
          } else {
            const existingAssignments = subCOEMap.get(item.subCOEEmployeeId).assignments;
            const alreadyExists = existingAssignments.some(a =>
              a.competencyId === item.competencyId &&
              a.subCompetencyId === item.subCompetencyId
            );
            if (!alreadyExists) {
              existingAssignments.push({
                competencyId: item.competencyId,
                subCompetencyId: item.subCompetencyId
              });
            }
          }
        }
        if (!competencyMap.has(item.competencyId)) {
          competencyMap.set(item.competencyId, {
            competencyId: item.competencyId,
            competencyName: item.competencyName,
            label: item.competencyName,
            value: item.competencyId,
            checked: false
          });
        }
        const pairKey = `${item.competencyId}-${item.subCompetencyId}`;
        if (!subCompetencyMap.has(pairKey)) {
          subCompetencyMap.set(pairKey, {
            competencyId: item.competencyId,
            subCompetencyId: item.subCompetencyId,
            competencyName: item.competencyName,
            subCompetencyName: item.subCompetencyName,
            label: `${item.competencyName} - ${item.subCompetencyName}`,
            value: [item.competencyId, item.subCompetencyId],
            checked: false
          });
        }
      });

      this.coeFilterOptions = Array.from(coeMap.values());
      this.subCOEFilterOptions = Array.from(subCOEMap.values()).sort((a, b) => a.label.localeCompare(b.label));
      this.competencyFilterOptions = Array.from(competencyMap.values());
      this.subCompetencyFilterOptions = Array.from(subCompetencyMap.values());
      this.loading = false;
    });
  }

  toggleSelection(row: any) {
    if (this.isRowSelctable(row)) {
      this.selection.toggle(row);
      this.cdr.detectChanges();
    }
  }

  toggleAllRows() {
    if (this.hasSelectableRows()) {
      this.isAllSelected()
        ? this.selection.clear()
        : this.dataSource.data.forEach(row => {
            if (this.isRowSelctable(row)) {
              this.selection.select(row);
            }
          });
      this.cdr.detectChanges();
    }
  }

  isAllSelected() {
    const selectedCount = this.selection.selected.length; 
    const selectableRows = this.dataSource.data.filter(row => this.isRowSelctable(row)).length;
    return selectableRows > 0 && selectedCount === selectableRows;
  }

  /** Check if selection is indeterminate (some but not all selectable rows are selected) */
  isIndeterminate() {
    return this.selection.selected.length > 0 && !this.isAllSelected();
  }

  isRowSelctable(row: any) {
    return ((row.employeeCompetencyRequestedId) &&((this.isSuperAdmin) || (row.coeEmployeeId == this.loggedInUserId) || (row.subCOEEmployeeIds.includes(this.loggedInUserId))));
  }

  hasSelectableRows() {
    return this.dataSource.data.some(row => this.isRowSelctable(row));
  }

  NoCompetencytoExcel() {
    this.GetNoCompetencyData(true);
  }

  convertAPIDataToExcel(x: any) {
    const worksheetData: any[] = [];
    // Header row
    worksheetData.push([
      { v: 'Employee Id', t: 's' },
      { v: 'First Name', t: 's' },
      { v: 'Last Name', t: 's' },
      { v: 'Email', t: 's' },
      { v: 'Source System Name', t: 's' },
      { v: 'Requested Competency Name', t: 's' },
      // { v: 'Requested Competency ID', t: 's' },
      { v: 'Requested Sub-Competency Name', t: 's' },
      // { v: 'Requested Sub-Competency ID', t: 's' },
      { v: 'Assigned Competency Name', t: 's' },
      // { v: 'Assigned Competency ID', t: 's' },
      { v: 'Assigned Sub-Competency Name', t: 's' },
      // { v: 'Assigned Sub-Competency ID', t: 's' },
      { v: 'Requested Date', t: 's' },
      { v: 'Primary Skills Updated', t: 's' },
      { v: 'Secondary Skills Updated', t: 's' },
      { v: 'Comments', t: 's' },
      { v: 'Manager Name', t: 's' },
      { v: 'COE Name', t: 's' },
      { v: 'Sub COE Name', t:'s'},
      { v: 'COE Contact Person', t: 's' },
      { v: 'Status', t: 's' }
    ]);

    x.data.items.forEach((i: any) => {
      const emailValue = i.emailAddress;
      const emailCell: any = { v: emailValue, t: 's' };

      if (this.isInvalidEmail(emailValue)) {
        emailCell.s = { font: { color: { rgb: "FFFF0000" } } };
      }

      const rowData = [
        { v: i.employeeId, t: 's' },
        { v: i.firstName, t: 's' },
        { v: i.lastName, t: 's' },
        emailCell,
        { v: i.sourceSystemName ? i.sourceSystemName : 'Not Available', t: 's' },
        { v: i.requestedCompetencyName ? i.requestedCompetencyName : 'Not Requested', t: 's' },
        // { v: i.requestedCompetencyId ? i.requestedCompetencyId : 'Not Requested', t: 's' },
        { v: i.requestedSubCompetencyName ? i.requestedSubCompetencyName : 'Not Requested', t: 's' },
        // { v: i.requestedSubCompetencyId ? i.requestedSubCompetencyId : 'Not Requested', t: 's' },
        { v: i.assignedCompetencyName ? i.assignedCompetencyName : 'Not Assigned', t: 's' },
        // { v: i.assignedCompetencyId ? i.assignedCompetencyId : 'Not Assigned', t: 's' },
        { v: i.assignedSubCompetencyName ? i.assignedSubCompetencyName : 'Not Assigned', t: 's' },
        // { v: i.assignedSubCompetencyId ? i.assignedSubCompetencyId : 'Not Assigned', t: 's' },
        { v: i.requestedDate ? i.requestedDate : 'Not Requested', t: 's' },
        { v: i.primarySkillsUpdated ? i.primarySkillsUpdated : 'Not Available', t: 's' },
        { v: i.secondarySkillsUpdated ? i.secondarySkillsUpdated : 'Not Available', t: 's' },
        { v: i.comments ? i.comments : 'Not Available', t: 's' },
        { v: i.managerName ? i.managerName : 'Not Available', t: 's' },
        { v: i.coeName ? i.coeName : 'Not Available', t: 's' },
        { v: i.subCOENames ? i.subCOENames : 'Not Available', t: 's' },
        { v: i.subspocNames ? i.subspocNames : 'Not Available', t: 's' },
        { v: i.employeeCompetencyRequestedId ? 'Requested For Change' : 'Unassigned', t: 's' }
      ];
      worksheetData.push(rowData);
    });

    if (worksheetData.length > 1) {
      const ws = XLSX.utils.aoa_to_sheet(worksheetData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'data');
      XLSX.writeFile(wb, 'Employees_Without_Competency.xlsx', { bookType: 'xlsx', type: 'binary' });
    } else {
      this.toaster.error("No data available to export");
    }
  }

  applyFilter(filterValue: string) {
    if (filterValue.length > 2 || filterValue.length == 0) {
      if (filterValue.includes('@')) {
        filterValue = filterValue.substring(0, filterValue.indexOf("@"));
      }
      this.searchText = filterValue;
      this.from = 0;
      this.size = 10;
      this.GetNoCompetencyData();
      this.selection.clear();
    }
  }

  isInvalidEmail(email) {
    const regex = /^[a-zA-Z0-9](?:[a-zA-Z0-9.]*[a-zA-Z0-9])?@(innovasolutions\.com|acsicorp\.com)$/;
    if (!regex.test(email) || email.includes('..') || email.includes(' ')) {
      return true;
    }
    return false;
  }

  GetNoCompetencyData(isExport: boolean=false) {
    this.loading = true;
    const selectedStatuses = this.statusOptions.filter(option => option.checked).map(option => option.value);
    const subCoePairs = [
        ...this.coeFilterOptions.filter(coe => coe.checked).flatMap(coe => coe.competencyIds.map(id => ({ competencyId: id, subCompetencyId: 0 }))),
        ...this.competencyFilterOptions.filter(competency => competency.checked).map(competency => ({ competencyId: competency.competencyId, subCompetencyId: 0 })),
        ...this.subCompetencyFilterOptions.filter(subCompetency => subCompetency.checked).map(subCompetency => ({ competencyId: subCompetency.competencyId, subCompetencyId: subCompetency.subCompetencyId })),
        //...this.subCOEFilterOptions.filter(subCOE => subCOE.checked).map(subCOE => ({ competencyId: subCOE.competencyId, subCompetencyId: subCOE.subCompetencyId }))
    ];
    this.subCOEFilterOptions.forEach(subCOE => {
      if (subCOE.checked) {
        subCOE.assignments.forEach(pair => {
          subCoePairs.push({
            competencyId: pair.competencyId,
            subCompetencyId: pair.subCompetencyId
          });
        });
      }
    });
    if (isExport) {
      this._competencyService.GetNoCompetencyData(this.searchText, 0, this.totalRecords, selectedStatuses, subCoePairs).subscribe(x => {
        this.convertAPIDataToExcel(x);
        this.totalRecords = x.data.total;
        this.loading = false;
      });
    } else {
      this._competencyService.GetNoCompetencyData(this.searchText, this.from, this.size, selectedStatuses, subCoePairs).subscribe(x => {
        this.dataSource = new MatTableDataSource(x.data.items ?? []);
        this.dataSource.sort = this.sort;
        this.totalRecords = x.data.total;
        this.loading = false;
      });
    }
  }

  getPaginatorData(event) {
    this.size = event.pageSize;
    this.from = event.pageIndex * this.size;
    if (this.skipNextPageEvent) {
      this.skipNextPageEvent = false;
      return;
    }
    this.GetNoCompetencyData();
  }

  OpenCompDialog() {
    const dialogRef = this.dialog.open(DialogForCompetencyComponent, {
      width: '570px',
      height: '410px',
      panelClass: 'view-file',
      data: {
        title: "isDefault",
        data: { totalEmployees: this.totalRecords }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this._competencyService.AddCompetencyinfo(result).subscribe(res => {
          if (res) {
            this.toaster.success("Successfully Added Competency Info");
            setTimeout(() => { this.GetNoCompetencyData(); }, 1000);
          } else {
            this.toaster.error("Something went wrong..");
          }
        });
      }
    });
  }

  edit(row: any): void {
    const dialogRef = this.dialog.open(EditCompetencyDialogComponent, {
      width: '926px',
      height: '540px',
      panelClass: 'editCompetencyDialog',
      data: { employee: row }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dataSource.data = this.dataSource.data.filter(entry => entry.emailAddress !== row.emailAddress);
        this.toaster.success('Successfully Added Competency Info');
      }
      else {
        // this.toaster.error("Something went wrong..Please try again.");
      }
    });
    
  }
  view(row: any): void {
    const dialog = this.dialog.open(ViewCompetencyDialogComponent, {
      width: '926px',
      height: '496px',
      minHeight: '491px',
      panelClass: 'view-competency-dialog',
      data: { employee: row }
    });
    dialog.afterClosed().subscribe(result=>{
      if (result)
        setTimeout(() => { this.GetNoCompetencyData(); }, 1000);    
    });
  }
  updateFilterStatus(){
    this.filterStatus =true;
  }
  clearSearch(): void {
    this.searchText = '';
    this.applyFilter('');
  }

  decline() {
    const action = "decline"
    const entity = "request"
    const dialogRef = this.dialog.open(ModularConfirmDialogComponent, {
      width: '493px',
      height: '240px',
      data: { action , entity}
    });
    
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const selectedIds = this.selection.selected.map(row => row.employeeCompetencyRequestedId);
        if (selectedIds.length > 0) {
          this._competencyService.DeclineEmployeesCompetencies(selectedIds).subscribe(response => {
            this.toaster.success("Declined Successfully.");
            setTimeout(() => { this.clearSearch(); }, 1000);
          }, error => {
            this.toaster.error("Please try again....");
          });
        }
      }
      else {
        this.selection.clear();
      }
    });    
  }

  approve() {
    const action = "approve"
    const entity = "request";
    const dialogRef = this.dialog.open(ModularConfirmDialogComponent, {
      width: '493px',
      height: '240px',
      data: { action , entity},
    });
    
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const selectedIds = this.selection.selected.map(row => row.employeeCompetencyRequestedId);
        if (selectedIds.length > 0) {
          this._competencyService.ApproveEmployeesCompetencies(selectedIds).subscribe(response => {
            this.selection.clear();
            this.toaster.success("Approved Successfully.");
            setTimeout(() => { this.clearSearch(); }, 1000);
          }, error => {
            this.toaster.error("Please try again....");
          });
        }
      }
      else {
        this.selection.clear();
      }
    });
  }

  resetPagination() {
    this.from = 0;
    this.size = 10;
    this.skipNextPageEvent = true;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
      this.paginator._changePageSize(this.size);
    }
  }

  resetFilters(excludeFilter?: string) {
    const filterGroups = [
        { key: 'subCOEFilterOptions', options: this.subCOEFilterOptions },
        { key: 'coeFilterOptions', options: this.coeFilterOptions },
        { key: 'competencyFilterOptions', options: this.competencyFilterOptions },
        { key: 'subCompetencyFilterOptions', options: this.subCompetencyFilterOptions },
        { key: 'statusOptions', options: this.statusOptions } // Only reset if requested
    ];
    filterGroups.forEach(group => {
        if (!excludeFilter || excludeFilter !== group.key) {
            group.options.forEach(option => option.checked = false);
        }
    });
    this.resetPagination();
    this.GetNoCompetencyData();
  }
}

